var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Specialist = require('./specialist.jsx');

var SpecialistList = createReactClass({
    mixins: [PureRenderMixin],

    getListNodes: function(){
        return this.props.specialists.filter(function(specialist){
            return specialist._id !== this.props.mySpecialist._id;
        }.bind(this)).map(function(specialist){
            return (
                <Specialist
                    key={specialist._id}
                    specialist={specialist}
                    setMySpecialist={this.props.setMySpecialist}
                    clearMySpecialist={this.props.clearMySpecialist}
                    token={this.props.token}
                    handleSpecialistUnauthenticatedUser={this.props.handleSpecialistUnauthenticatedUser}
                    clickTracking={this.props.clickTracking} />
            );
        }.bind(this));
    },

    render: function(){
        return (
            <ul className="specialist-list no-bullet">
                {this.getListNodes()}
            </ul>
        )
    }
});

module.exports = SpecialistList;



// WEBPACK FOOTER //
// ./src/common/routes/find-a-specialist/components/layout/specialistList.jsx